<div class="w-full max-w-[800px] px-4 sm:px-8 md:px-12 py-6 sm:py-8">

  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <div style="background: #fee2e2; border-radius: 12px; padding: 10px; display: flex; align-items: center; justify-content: center;">
      <mat-icon style="color: #dc2626; font-size: 24px; width: 24px; height: 24px;">block</mat-icon>
    </div>
    <div>
      <h2 style="font-size: 1.25rem; font-weight: 700; color: #111827; margin: 0;">Rechazar transaccion</h2>
      <p style="font-size: 0.8rem; color: #6b7280; margin: 0;">Indique el motivo del rechazo de la transferencia</p>
    </div>
  </div>

  <!-- Formulario -->
  <form [formGroup]="datosForm" class="w-full" *ngIf="datosForm">
    <div class="grid grid-cols-1 gap-4">
      <mat-form-field appearance="outline" class="w-full modern-field">
        <mat-label>Motivo del rechazo</mat-label>
        <mat-icon matPrefix style="color: #dc2626; margin-right: 8px;">report_problem</mat-icon>
        <mat-select required formControlName="motivo">
          <mat-option>Seleccione un motivo</mat-option>
          <mat-option *ngFor="let motivo of motivosRechazo" [value]="motivo">
            {{ motivo }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="grid grid-cols-1 gap-4">
      <mat-form-field appearance="outline" class="w-full modern-field">
        <mat-label>Descripcion del rechazo</mat-label>
        <mat-icon matPrefix style="color: #6b7280; margin-right: 8px;">notes</mat-icon>
        <textarea
          maxlength="100"
          #input
          matInput
          formControlName="comentario"
          placeholder="Opcional - maximo 100 caracteres"
          rows="3"
        ></textarea>
        <mat-hint align="end">{{ input.value.length }}/100</mat-hint>
      </mat-form-field>
    </div>
  </form>

  <!-- Botones -->
  <div class="flex flex-col sm:flex-row justify-center gap-3 sm:gap-6 w-full mt-6">
    <button type="button" (click)="rejectTransaction()" [disabled]="datosForm?.invalid"
      class="w-full sm:w-1/2 text-center"
      style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 10px 36px; background: #dc2626; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
      [style.background-color]="datosForm?.valid ? '#dc2626' : '#d1d5db'"
      [style.color]="datosForm?.valid ? 'white' : '#9ca3af'"
      [style.cursor]="datosForm?.valid ? 'pointer' : 'not-allowed'"
      onmouseover="this.style.background='#b91c1c'" onmouseout="this.style.background='#dc2626'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle; margin-right: 4px;">cancel</mat-icon>
      Rechazar
    </button>
    <button type="button" (click)="close()"
      class="w-full sm:w-1/2 text-center"
      style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
      onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
      Cancelar
    </button>
  </div>

</div>
